module.exports = __webpack_public_path__ + "static/media/skull-cow.f49c1da3.svg";